import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsMarketingPreferencesForm } from '../../models/cms/cms-marketing-preferences-form.interface';

export const mockCmsMarketingPreferencesForm: CmsMarketingPreferencesForm = {
  marketingPreferenceEmailField: mockFormField,
  marketingPreferenceFieldset: mockFormFieldset,
  marketingPreferencePostField: mockFormField,
  marketingPreferenceTelephoneField: mockFormField,
};
